import React, { Component } from 'react';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import store from '../../../../store';
import { selectItem } from '../../../navigator/action';

export default class NavigatorTool extends Component {

    getNavAction() {
        var action = this.props.type;
        var { currentSceneName, scene } = this.props.vrtour;
        var currentItemIndex = scene.findIndex(v => v.name === currentSceneName);
        var scene;
        if (action == "next") {
            scene = scene[currentItemIndex + 1];
        } else if (action == "prev") {
            scene = scene[currentItemIndex - 1];
        }
        console.log("scene :", scene);
        if (scene == null) return;
        store.dispatch(selectItem(scene.name));
    }

    getNavActionButton() {
        if (this.props.type == "next") {
            if (window.config.toolbar?.nav?.icon_next != null)
                return <img src={`${process.env.PUBLIC_URL}/data/${window.config.toolbar?.nav?.icon_next}`} />
            return <FiArrowRight />
        } else if (this.props.type == "prev") {
            if (window.config.toolbar?.nav?.icon_prev != null)
                return <img src={`${process.env.PUBLIC_URL}/data/${window.config.toolbar?.nav?.icon_prev}`} />
            return <FiArrowLeft />
        }
    }

    render() {
        if (!window.config.toolbar?.nav?.display) return "";
        return (
            <div className="tool-item">
                <div className="item-icon" onClick={() => this.getNavAction.call(this)}>
                    {this.getNavActionButton.call(this)}
                </div>
            </div>
        )
    }
}
